export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-08.42e76629.jpg";